import {Stack, VStack} from 'platform/foundation';

import {ReactNode} from 'react';

interface PricingColumnsProps {
  isSideBySide: boolean;
  left: ReactNode;
  right: ReactNode;
}

// Both layouts render the same tree, so a width change never remounts the sections and their unsaved values.
export function PricingColumns(props: PricingColumnsProps) {
  const grow = props.isSideBySide ? 1 : undefined;
  const basis = props.isSideBySide ? 0 : undefined;

  return (
    <Stack direction={props.isSideBySide ? 'row' : 'column'} spacing={4}>
      <VStack spacing={4} grow={grow} basis={basis} minWidth={0}>
        {props.left}
      </VStack>
      <VStack spacing={4} grow={grow} basis={basis} minWidth={0}>
        {props.right}
      </VStack>
    </Stack>
  );
}
